import React, { useEffect } from 'react';
import { useStyles } from '../../styles';
import { useStateMachine } from 'little-state-machine';
import { updateAction } from '../../actions';
import { useForm, Controller } from 'react-hook-form';
import '../../../../../css/forms.css';
import { IFormProps } from './section.interface';
import { Typography, Grid, Divider, TextField, Button, Stack, Box } from '@mui/material';
import { Colors } from '../../../../../enums/enums';

const Section3: React.FC<IFormProps> = ({ step, setStep }) => {
  const { state, actions } = useStateMachine({
    updateAction
  });

  const {
    handleSubmit,
    getValues,
    control,
    formState: { errors }
  } = useForm({
    defaultValues: state?.formDetails?.all
  });

  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    const partialData = getValues();
    actions.updateAction({ formDetails: { all: partialData } } as any);
    setStep(step - 1);
  };

  const onSubmit = (data: any) => {
    actions.updateAction({ formDetails: { all: data } } as any);
    setStep(step + 1);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Divider sx={{ mb: 6 }} />
      <Grid className={classes.formContent} container spacing={5} alignItems="center" justifyContent="center">
        <Stack sx={{ width: '667px', ml: 4 }} spacing={3}>
          <Box>
            <Typography sx={{ mt: 3, mb: 1 }}>Preferred Learning Style </Typography>
            <Typography sx={{ color: Colors.TextElevated, fontSize: '12px', mb: 2, width: '667px' }}>
              How do you prefer to learn? (e.g., one-on-one sessions, group sessions, through written material, video
              content, etc.)
            </Typography>
            <Controller
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                  color="success"
                />
              )}
              name="learningStyle"
              control={control}
            />
          </Box>

          <Box>
            <Typography sx={{ mb: 1 }}>Career Goals </Typography>
            <Typography sx={{ color: Colors.TextElevated, fontSize: '12px', mb: 2, width: '667px' }}>
              What are your career goals or topics you want to learn more about.
            </Typography>
            <Controller
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  multiline
                  rows={3}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                  color="success"
                />
              )}
              name="careerGoals"
              control={control}
            />
          </Box>

          <Box>
            <Typography sx={{ mb: 1 }}>Accessibility Needs </Typography>
            <Typography sx={{ color: Colors.TextElevated, fontSize: '12px', mb: 2, width: '667px' }}>
              Do you have any accessibility needs or preferences for communication and material formats that we should
              be aware of to better accommodate you during the program?
            </Typography>
            <Controller
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                  color="success"
                />
              )}
              name="accessibility"
              control={control}
            />
          </Box>
        </Stack>

        <Grid item className={classes.buttonContainter}>
          <Button className={classes.button} variant="outlined" color="success" onClick={() => handleBack()}>
            BACK
          </Button>
        </Grid>

        <Grid item className={classes.buttonContainter}>
          <Button className={classes.button} variant="contained" color="success" type="submit">
            NEXT
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default Section3;
